import styled from 'styled-components'

export const ProjectsPickerWrapper = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 16px;
  flex: 1 0 0;
`
